import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children, isAdminRequired }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token'); // ✅ thêm dòng này
    const location = useLocation();
    const navigate = useNavigate();

    // 🔥 FIX: CHẶN BACK / FORWARD
    useEffect(() => {
        if (!token) {
            navigate('/login', { replace: true });
        }
    }, [navigate, token]);

    // chưa login (check theo token)
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // ===== NORMALIZE ROLE =====
    let role = user?.role;

    if (typeof role === 'number') role = String(role);
    role = role?.toLowerCase().trim();

    if (role === '1') role = 'admin';
    if (role === '2') role = 'user';
    if (role === '3') role = 'student';

    const path = location.pathname;

    // ===== 🔥 CHẶN SETTINGS =====
    if (path === '/admin/settings') {
        if (role !== 'admin') {
            return <Navigate to="/dashboard" replace />;
        }
    }

    // ===== GIỮ LOGIC CŨ =====
    if (isAdminRequired && role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;